import { EdgeLocationGroup, EdgeLocationTableRow } from './types';

/**
 * Flattens the nested edge-location group structure into the flat row model
 * consumed by {@link SearchableTable}. Within each group the default
 * configuration is rendered first (enforced by the query hook). The row
 * carries enough context (group id, edge location name) for cell renderers
 * to render themselves without any further lookups.
 */
export const flattenEdgeLocationGroups = (
  groups: EdgeLocationGroup[]
): EdgeLocationTableRow[] =>
  groups.flatMap((group) =>
    group.configurations.map((configuration, index) => ({
      id: configuration.id || `${group.edgeLocationId}-${index}`,
      edgeLocationId: group.edgeLocationId,
      edgeLocationName: group.edgeLocationName,
      configuration,
    }))
  );

/**
 * The Edge location column shows the location name only on the first visible
 * configuration of each group. Runs on the filtered rows so searching for a
 * configuration that isn't the group leader still surfaces its location.
 */
export const markFirstVisibleRowsByEdgeLocation = (
  rows: EdgeLocationTableRow[]
): EdgeLocationTableRow[] =>
  rows.map((row, rowIndex) => ({
    ...row,
    isFirstInGroup:
      rowIndex === 0 ||
      rows[rowIndex - 1]?.edgeLocationId !== row.edgeLocationId,
  }));
